import { apiClient } from 'api'
import { User } from 'types/users'

type NewItem = Omit<User, 'id'>

export const getUsers = () => apiClient.get<User[]>('/users')

export const getUserById = (id: number) => apiClient.get<User>(`/users/${id}`)

export const createUser = (user: NewItem) => apiClient.post<NewItem, User>('/users', user)

export const editUser = (user: User) => apiClient.patch<User>(`/users/${user.id}`, user)

export const deleteUser = (id: number) => apiClient.delete(`/users/${id}`)

export const blockUser = (id: number) => apiClient.get(`/users/block/${id}`)

export const activateUser = (id: number) => apiClient.get(`/users/activate/${id}`)

export const setUserPassword = (id: number, password: string) =>
    apiClient.patch(`/users/setPassword/${id}`, { password })
